import { createSelector } from 'reselect';
import { d, ROOT_MEDIA, ROOT_SECTION, sortBy, VERSION } from 'shared-base';
import { authors } from '../data/data.authors';
import { browseIdeas } from '../data/data.browse';
import * as base from './selectors.base';
import { raw } from './selectors.raw';

export const $generators = createSelector(
  base.$generators,
  raw.$rawSettings,
  (generators, settings) => {
    const { sortGeneratorsById } = settings;
    const sortField = sortGeneratorsById ? 'id' : 'order';

    const output = generators
      .map((generator) => {
        const { id, name } = generator;

        return {
          ...generator,
          imageUrl: generator.thumbUrl + `?${VERSION}`,
          title: name + ' Generator',
        };
      })
      .sort(sortBy(sortField));

    return [{ id: 'fixed', name: '', tags: [] }, ...output];
  }
);

export const $projects = createSelector(base.$projects, (projects) => {
  return projects
    .map((project) => {
      const { name, modifiedAt, thumbnail } = project;

      return {
        ...project,
        imageUrl: thumbnail,
        title: name,
        daysAgoText: d.timeAgo(modifiedAt),
      };
    })
    .sort(sortBy('modifiedAt', 'desc'));
});

export const $materials = createSelector(base.$materials, (materials) => {
  const ROOT = ROOT_SECTION('materials');

  return materials
    .map((material, index) => {
      const { id } = material;

      return {
        index,
        ...material,
        title: id.replace(/a$/, ''),
        imageUrl: `${ROOT}/${id}.jpg?${VERSION}`,
        thumbUrl: `${ROOT}/${id}.thumb.jpg?${VERSION}`,
      };
    })
    .sort(sortBy('id')) as IMaterial[];
});

export const $backdrops = createSelector(base.$backdrops, (backdrops) => {
  return backdrops
    .map((backdrop, index) => {
      const { id, name } = backdrop;

      return {
        index,
        ...backdrop,
        title: name,
        imageUrl: `${ROOT_MEDIA}/backdrops/${id.toUpperCase()}.jpg?${VERSION}`,
        thumbUrl: `${ROOT_MEDIA}/backdrops/${id.toUpperCase()}.thumb.jpg?${VERSION}`,
      };
    })
    .sort(sortBy('id'));
});

export const $shaders = createSelector(base.$shaders, (shaders) => {
  return shaders.map((shader, index) => {
    const { id } = shader;

    return {
      index,
      ...shader,
      imageUrl: `${ROOT_MEDIA}/shaders/${id.toLowerCase}.jpg?${VERSION}`,
      thumbUrl: `${ROOT_MEDIA}/shaders/${id.toLowerCase()}.thumb.jpg?${VERSION}`,
    };
  });
});

export const $assetPacks = createSelector(
  base.$assetPacks,

  (assetPacks) => {
    return assetPacks.map((assetPack) => {
      const { name, thumbnail } = assetPack;

      return {
        ...assetPack,
        imageUrl: thumbnail,
        title: name,
      };
    });
  }
);

export const $browse = createSelector(raw.$rawCurrentIds, (i) => {
  return browseIdeas.map((idea) => {
    const { authorId, modifiedAt } = idea;
    const author = authors[authorId];

    const ROOT = ROOT_SECTION('browse-ideas', true);
    const imageUrl = `${ROOT}/browse-${idea.id}.1200.png?${VERSION}`;
    const thumbUrl = `${ROOT}/browse-${idea.id}.150.png?${VERSION}`;
    const uploaderAvatar = `${ROOT_MEDIA}/avatars/avatar-${authorId}.png?${VERSION}`;

    return {
      ...idea,
      imageUrl,
      thumbUrl,
      daysAgo: d.daysFromNow(modifiedAt),
      daysAgoText: d.timeAgo(modifiedAt),
      uploaderName: author.nickname,
      uploaderAvatar,
    };
  });
});
